import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FaqDataInfo, FaqGroupInfo, FaqInfo } from './shared-constants';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FaqService {
	constructor(
		private db: SpaqFireDb,
		private afAuth: AngularFireAuth
	) {}

	add(faq: FaqInfo): Observable<any> {
		const faqObj = { ...faq };
		delete faqObj.id;

		return from(this.db.pushFaqItem(faq.organization, faqObj)).pipe(map(_x => faq));
	}

	addGroup(faq: FaqGroupInfo): Observable<any> {
		const faqObj = { ...faq };
		delete faqObj.id;
		return from(this.db.pushFaqGroup(faq.organization, faqObj)).pipe(map(_x => faq));
	}

	delete(faq: FaqInfo): Observable<any> {
		return from(this.db.removeFaqItem(faq.organization, faq.id)).pipe(map(_x => faq));
	}

	deleteGroup(faq: FaqGroupInfo): Observable<any> {
		return from(this.db.removeFaqGroup(faq.organization, faq.id)).pipe(map(_x => faq));
	}

	getAll(): Observable<any> {
		return this.db.faq$();
	}

	getAllGroups(): Observable<any> {
		return this.db.faq$();
	}

	getAllVisible(organization): Observable<FaqDataInfo> {
		return this.db.faq$<FaqDataInfo>().pipe(
			map(a => {
				const f: any = a[organization];
				const s = a['_system'];

				const data = {
					groups: Object.keys(f.groups || {})
						.map(k => ({ ...f.groups[k], id: k }))
						.filter((x: any) => !!x.visible),
					list: Object.keys(f.list || {})
						.map(k => ({ ...f.list[k], id: k }))
						.filter((x: any) => !!x.visible)
				};
				const systemData = {
					groups: Object.keys(s.groups || {})
						.map(k => ({ ...s.groups[k], id: k }))
						.filter((x: any) => !!x.visible),
					list: Object.keys(s.list || {})
						.map(k => ({ ...s.list[k], id: k }))
						.filter((x: any) => !!x.visible)
				};
				data.groups = [...data.groups, ...systemData.groups];
				data.list = [...data.list, ...systemData.list];

				return data;
			})
		);
	}

	update(faq: FaqInfo): Observable<any> {
		const faqObj = { ...faq };
		delete faqObj.id;
		return from(this.db.updateFaqItem(faq.organization, faq.id, faqObj)).pipe(map(_x => faq));
	}

	updateGroup(faq: FaqGroupInfo): Observable<any> {
		const faqObj = { ...faq };
		delete faqObj.id;
		return from(this.db.updateFaqGroup(faq.organization, faq.id, faqObj)).pipe(map(_x => faq));
	}
}
